import { IconButton, SvgIcon, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { ReactComponent as Close } from 'assets/images/dialog-icon-close/close.svg';
import pxToRem from 'assets/theme/function/px-to-rem';

interface Props {
    handleClose: any;
}

const DialogIconClose: React.FC<Props> = (props: Props) => {
    const { handleClose } = props;

    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <IconButton
                onClick={handleClose}
                aria-label="close"
                sx={{
                    position: 'absolute',
                    right: isSmDown ? 2 : 8,
                    top: 2,
                }}
            >
                <SvgIcon
                    component={Close}
                    inheritViewBox
                    sx={{
                        fontSize: {
                            md: pxToRem(30),
                        },
                    }}
                />
            </IconButton>
        </>
    );
};
export default DialogIconClose;
